<mat-card class="card-process-wrapper">
  <mat-card-title class="card-process-title">{{ title }}</mat-card-title>
  <mat-card-content class="card-process-content">{{
    content
  }}</mat-card-content>
</mat-card>
<mat-card> </mat-card>
